/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';
import some from 'lodash/some'
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';

import { changeStatusDocument, deleteDocument } from '@actions/documents';
import { sendActionToBitacora  } from '@actions/bitacora';

import { LANGUAGE_DEFAULT } from '@constants/general'

class DeleteAuthorizedModalDocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      justification: '',
      errors: [],
      transactionNameOpt: ''
    }
  }

  componentDidUpdate (prevProps) {
    if (!prevProps.display && this.props.display) {
      this.setState({
        justification: '',
        errors: []
      })
    }
  }

  onSubmit = async (actionType) => {
    // e.preventDefault();
    const validate = await this.validateFieldsReject()
    if (some(validate, {})) return true
		actionType()
  }

  sendCommentToBitacora = async () => {
    const { sendActionToBitacora, data } = this.props
    const { transactionNameOpt, justification } = this.state
    const nameSection = data.nombre[LANGUAGE_DEFAULT]
    const dataBitacora = {
      transactionName: transactionNameOpt || 'Documento',
      reason: `${nameSection} || ${justification}`,
    }
    await sendActionToBitacora(dataBitacora)
  }

	onReactiveDocument = async () => {
		const { deleteDocument, data, onContinueAction, onHidden, sectionTree } = this.props
		const { justification } = this.state
    const type = "reactivate"
		const response = await deleteDocument({id: data.id, type, justification, selectedNavegationTree: data.id_seccion})
		if (!response?.status) {
      await this.setState({ transactionNameOpt: 'reactivarDocumento' })
      await this.sendCommentToBitacora()
			onContinueAction()
		}
		return onHidden()

	}

	onConfirmDeleteDocument = async () => {
		const { deleteDocument, data, onContinueAction, onHidden, sectionTree } = this.props
		const { justification } = this.state
    const type = "physical"
		const response = await deleteDocument({id: data.id, type, justification, selectedNavegationTree: data.id_seccion})
		if (!response?.status) {
      await this.setState({ transactionNameOpt: 'bajaFísicaDocumento' })
      await this.sendCommentToBitacora()
			onContinueAction()
		}
		return onHidden()
	}

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state
    if (errors[name] && value) {
      delete errors[name]
      this.setState({errors})
    }
  }

  validateFieldsReject = async () => {
    const { t, label } = this.props
    const { justification } = this.state
    let errors = {}
    if (!justification) errors = { ...errors, 'justification': `${t( label || 'Justificación del cambio')} ${t('es requerido')}`}
    this.setState({errors})
    return errors
  }

  isFormFieldValid = (name) =>
    !!(this.state.errors[name]);

  getFormErrorMessage = (name) =>
    this.isFormFieldValid(name) && (
      <small className="p-error">{this.state.errors[name]}</small>
    );
  
  render () {
    const { t, display, onHidden, description } = this.props

    const children = (
      <div className="p-mt-2 p-fluid">
        <div className="p-col p-pb-3 p-text-center">
          <label className="">{description}</label>
        </div>
        <div className="p-col">
          <label className="">{t('El usuario Juan López solicito la eliminación de esta sección')}</label>
          <br/>
          <br/>
          <label className="">{t('¿Esta seguro que desea eliminar definitivamente este documento?')}</label>
        </div>
				<br/>
				<br/>
        <div className="p-col">
          <label className="">{t('Justificación del cambio')}</label>
        </div>
        <InputTextarea
          name="justification"
          onChange={(e) =>
            this.setState({ justification: e.target.value }, this.validateFieldsOnchange('justification', e.target.value))
          }
          rows={5}
          cols={30}
          className={classNames({
            'p-invalid': this.isFormFieldValid(`justification`),
          })}
        />
        {this.getFormErrorMessage(`justification`)}
        <div className="p-dialog-footer custom">
          <div className="p-d-flex p-jc-sm-between">
            <button className="p-button p-component p-button-raised p-button-secondary p-button-text p-mr-5" type="button" onClick={() => onHidden()}>
              <span className="p-button-label p-c">Cerrar</span>
            </button>
						<div>
							<button className="p-button p-button-success p-component" onClick={() => this.onSubmit(() => this.onReactiveDocument())}>
								<span className="p-button-label p-c">{t('Reactivar documento')}</span>
							</button>
							<button className="p-button p-button-danger p-component" onClick={() => this.onSubmit(() => this.onConfirmDeleteDocument())}>
								<span className="p-button-label p-c">{t('Eliminar documento')}</span>
							</button>
						</div>
          </div>
        </div>
      </div>
    )

    return (
      <Dialog
        header={t('Eliminación de un documento autorizado')}
        visible={display}
        breakpoints={{'960px': '75vw'}}
        style={{ width: '50vw' }}
        onHide={onHidden}
      >
        {children}
      </Dialog>
    )
  }
}

const mapDispatchToProps = {
  changeStatusDocument,
	deleteDocument,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
  )(DeleteAuthorizedModalDocument)